
<div class="home-container mt-5" id="ppc-report">
  <div class="row mb-5">
    <div class="col">
      <p class="font-weight-light small">Country</p>
      <p class="border-bottom">{{ppcDetails.country}}</p>
    </div>
    <div class="col">
      <p class="font-weight-light small">Type of Protection</p>
      <p class="border-bottom">{{ppcDetails.protectionType}}</p>
    </div>
    <div class="col">
      <p class="font-weight-light small">Filing Route</p>
      <p class="border-bottom">{{ppcDetails.filingRoute}}</p>
    </div>
    <div class="col">
      <p class="font-weight-light small">Technical field of the invention</p>
      <p class="border-bottom">{{ppcDetails.technicalField}}</p>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <p class="font-weight-light small">{{ppcDetails.filingRoute == "PCT National Application" ? "National Phase Entry Date":"Filing Date"}}</p>
      <p class="border-bottom">{{ppcDetails.filingDate}}</p>
    </div>
    <div class="col text-right"><p class="mt-3">Estimated Grant Date:</p></div>
    <div class="col"><div class="alert alert-primary text-center">{{ppcDetails.estimatedGrantDate}}</div></div>
  </div>

  <div class="row mt-5">
    <img src="{{timelineImage}}" class="img-fluid" />
  </div>

  <!--[dynamicResize]="true"-->
  <ng-template [ngIf]="ppcDetails.steps.length > 0">
    <div class="row">
      <div class="col-6"></div>
      <div class="col-4">
        <div class="row">
          <div class="col-6 text-center"><p class="lead">from</p></div>
          <div class="col-6 text-center"><p class="lead">to</p></div>
        </div>
      </div>
      <div class="col-2">Fee</div>
    </div>

    <div *ngFor="let step of ppcDetails.steps">
      <div class="row">
        <div class="col-6"><p>– {{step.name}}</p></div>
        <div class="col-4">
          <div class="row">
            <div class="col-6 text-center"><p>{{step.fromDate}}</p></div>
            <div class="col-6 text-center"><p>{{step.toDate}}</p></div>
          </div>
        </div>
        <div class="col-2"><p>{{step.cost}}</p></div>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="showSingaporeContent()">
    <div class="custom-content-holder">
      Publication of the application is not required for the applicant to request for examination in Singapore. Publication of the full application occurs automatically 18 months from the priority date and the applicant can request for early publication if desired.
    </div>
  </ng-template>
  <br />
  <ng-template [ngIf]="showSingaporeContent()">
    <div class="custom-logo-holder">
      <img src="{{singaporeLogo}}" />
    </div>
    <div class="custom-content-holder">
      Data have been graciously provided by AMICA LAW LLC.
    </div>
  </ng-template>
</div>
